import { IRuleGroupService } from "../../service/evaluation/RuleGroupService";
import { IRuleGroup } from "../../model/evaluation/RuleGroup";

export default class CreateRuleGroupInteractor {
  private ruleGroupService: IRuleGroupService;

  constructor(ruleGroupService) {
    this.ruleGroupService = ruleGroupService;
  }

  async execute(ruleGroup: IRuleGroup) {
    return this.ruleGroupService.createRuleGroup(ruleGroup);
  }
}
